module.exports = __webpack_public_path__ + "img/addblock.18982e5b.svg";